import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/eratecsolution/htdocs/www.eratecsolution.com/app/ecommerce-website-development-services/FaqSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/eratecsolution/htdocs/www.eratecsolution.com/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/eratecsolution/htdocs/www.eratecsolution.com/node_modules/next/dist/client/image-component.js");
